// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GhPC","newExpiryDate":"styles_newExpiryDate__14FbX","footer":"styles_footer__3NYRA"};